// extracted by mini-css-extract-plugin
export default {"pTitle":"adminVerkstedCard_pTitle__G+bDn","adminVerkstedCard":"adminVerkstedCard_adminVerkstedCard__GRUAn","image":"adminVerkstedCard_image__yjaAK"};